import type {
  BatMetadataConfigEntry,
  FieldMetadataMessageDescriptorDef,
} from './common/types';
import { coreFields } from './common/coreFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';

const kgco2eRemoved: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'kgCO₂e removed',
    context: 'The quantity of greenhouse gases removed.',
  }),
  externalDescription: msg({
    message: 'The quantity of greenhouse gases removed.',
    context: 'kgCO₂e removed',
  }),
};

export const carbonRemovalMetadata = {
  displayName: msg({
    message: 'Carbon removal',
    context: 'Activity data schema name for carbon removal',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    carbon_removal_kind: {
      displayName: msg({
        message: 'Carbon removal activity kind',
        context: 'The category of carbon removal activity.',
      }),
    },
    kgco2e_removed: kgco2eRemoved,
    // NOTE: quantity does not exist on the BAT but kgco2e_removed is
    // renamed to quantity in the BART-EM matching process
    quantity: kgco2eRemoved,
  },
} as const satisfies BatMetadataConfigEntry;
